// Small "R" marker shown next to a client name when that client has prior-period
// charges queued to roll into their next invoice. Amber for a positive amount
// (extra to bill), slate for a net credit — either way it means "open this
// client's Rollover tab". Amount is in the tooltip so the tables stay clean.

export default function RolloverBadge({ amount = 0, items = 0 }) {
  const v = Number(amount) || 0
  if (!items && v === 0) return null

  const credit = v < 0
  const money = `${credit ? '-' : ''}$${Math.abs(v).toFixed(2)}`

  return (
    <span
      title={`Rollover: ${money} across ${items} item${items === 1 ? '' : 's'} — will be added to the next invoice (not in MTD). See the client's Rollover tab.`}
      className={[
        'inline-flex items-center justify-center w-5 h-5 rounded text-[11px] font-bold leading-none shrink-0 cursor-help',
        credit
          ? 'bg-slate-200 text-slate-600'
          : 'bg-amber-100 text-amber-700 ring-1 ring-amber-300',
      ].join(' ')}
    >
      R
    </span>
  )
}
